import React, { FC } from "react";

import Context from "./../../components/Context";

const ContextListPage: FC = () => <Context />;

export default ContextListPage;
